<template>
	<select :value="value" @change="$emit('input', $event.target.value)">
		<option v-for="(option, i) in options" :key="i" :value="option" :selected="option == value">{{ option }}</option>
	</select>
</template>

<script>
	export default {
		props: {
			value: [String, Number],
			options: Array,
		},
	};
</script>

<style scoped>
	select {
		padding: 10px;
		font: inherit;
		background-color: #FFFFFF;
		border: 1px solid #CECECE;
		outline: none;
		background-image: url(../../public/icons/select-arrow.svg);
		background-size: 13px 8px;
		background-repeat: no-repeat;
		background-position: calc(100% - .4em) 50%;
		appearance: none;
	}
</style>